//For UAT
// export const containerAccount = 'aztatvaprodstorage'

//For Prod
export const containerAccount = 'mytatvaprodstorage'
